<template>
  <v-row justify="center">
    
    <v-col cols="12" md="8">
      <v-card class="mx-auto rounded-xl"> 
        <v-card-title class="indigo white--text">
          <!-- Bill Title -->
          <v-row>
            <v-col cols="12">
              <v-text-field dark prepend-icon="mdi-receipt" color="white"
                :disabled="!editMode" 
                v-model="bill.billName" 
                label="Bill Name"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <!-- Bill Items -->
          <v-container>
            <v-row>
              <!-- Bill Date -->
              <v-col cols="12">
                <v-dialog
                  ref="dateDialog"
                  v-model="dateDialog.show"
                  :return-value.sync="bill.billDate"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :disabled="!editMode"
                      v-model="formattedBillDate"
                      label="Date (mm/dd/yyyy)"
                      prepend-icon="mdi-calendar"
                      @click:prepend-icon="dateDialog.show = true"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="bill.billDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateDialog.show = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dateDialog.save(bill.billDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12">
                <v-combobox v-model="bill.trip" prepend-icon="mdi-airplane"
                  :disabled="!editMode"  
                  persistent-hint hint="What trip is this associated with?"
                  label="Trip"
                  :items="trips" item-text="name" item-value="name"
                >
                </v-combobox>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12" class="text-center">
                <p class="text-subtitle-1" style="text-decoration: underline;">Bill Items</p>
              </v-col>
            </v-row>
            
            <v-row v-for="item in bill.billItems" :key="item.id" align="center">
              <v-col>
                <v-text-field :disabled="!editMode" v-model="item.title" label="Item Name"></v-text-field>
              </v-col>
              <v-col sm="2">
                <v-text-field :disabled="!editMode" v-model="item.cost" label="Item Cost" type="number"></v-text-field>
              </v-col>
              
              <!-- Splitters --> 
              <v-col cols="12">
                <v-chip class="mx-3"
                  :close="editMode" v-for="(p, index) in item.peopleCombo" :key="index" :disabled="!editMode"
                  @click:close="removePersonFromBill(p, item.id)"
                >
                  <v-avatar
                    class="accent white--text"
                    left
                    v-text="p.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ p }}
                </v-chip>

                <v-menu v-if="editMode" :close-on-content-click="false">
                  <template v-slot:activator="{ on , attrs }">
                    <v-btn rounded outlined color="success" v-on="on" v-bind="attrs">
                      Add Person
                      <v-icon right>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="addPersonToBillItem(person, item.id)" v-for="person in mergedDiners(bill.billItems)" :key="person">
                      <v-list-item-title v-text="person"></v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-text-field @click:append="addNewPerson" label="New Person" append-icon="mdi-plus"></v-text-field>
                      <!-- <v-list-item-title>New Person</v-list-item-title> -->
                      <!-- <v-list-item-icon><v-icon>mdi-plus</v-icon></v-list-item-icon> -->
                    </v-list-item>
                  </v-list>
                </v-menu> 
              </v-col>
              
              <v-col cols="12" class="pa-0">
                <v-divider></v-divider>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-right">
                <p class="text-right"> Bill SubTotal: <span><strong>${{formattedBillSubTotal}}</strong></span></p>
              </v-col>
            </v-row>

            <v-row class="pt-2">
              <v-col cols="12" class="text-center">
                <div class="text-subtitle-1" style="text-decoration: underline;">Total By Person</div>
              </v-col>
            </v-row>

            <v-row v-for="person in billByPersonSubTotal" :key="person.id" align="center">
              <v-col>
                <v-chip>
                    <v-avatar
                      class="accent white--text"
                      left
                      v-text="person.name.slice(0, 1).toUpperCase()"
                    ></v-avatar>
                    {{ person.name }}
                  </v-chip>
                <!-- <h4 class="text-body-2">{{person.name}}</h4> -->
              </v-col>

              <v-col sm="2">
                <h4 class="text-body-2 text-center">${{person.total.toFixed(2)}}</h4>
              </v-col>

              <v-col cols="12" class="pa-0">
                <v-divider></v-divider>
              </v-col>
            </v-row>

          </v-container>

          <v-dialog v-model="shareDialog" max-width="350">
            <v-card>
              <v-card-title class="headline">Share</v-card-title>
              <v-card-text>
                <div style="white-space: pre;">{{ billShareText }}</div>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="shareDialog = false">Cancel</v-btn>
                <v-btn text @click="copyToClipboard(billShareText)">Copy</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-text>
        <v-card-actions>
          <!-- Need to add back in @click="shareBill" -->
          <v-btn rounded @click="editMode ? saveBill() : editMode = true " :color="editMode ? 'success' : 'info'">
            {{editMode ? 'Save' : 'Edit'}} <v-icon right>{{editMode ? 'mdi-update' : 'mdi-pencil'}}</v-icon>
          </v-btn>
          
          <v-btn rounded v-if="editMode" @click="cancelEdit()" title color="error">
            Cancel<v-icon right>mdi-pencil-off</v-icon>
          </v-btn>

          <v-spacer></v-spacer> 

          <v-btn rounded @click="shareBill" class="mx-2" color="success">
            Share <v-icon right>mdi-share-variant</v-icon>
          </v-btn>

        </v-card-actions>
        
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  export default {
      name: 'BillItem',
    
      data: () => ({
        bill: {}, 
        originalBill: {},

        dateDialog: {
          show: false
        }, 

        edits: [],
        // billSubTotal: 0.00,
        // billByPersonSubTotal: [],
        
        shareDialog: false,
        editMode: false, 
        openMenu: false,

        trips: [],

      }), 
      computed: {
        billId(){
          return this.$route.params.id;
        },

        formattedBillSubTotal(){
          return this.billSubTotal.toFixed(2);
        }, 

        formattedBillDate() {
          return this.formatDate(this.bill.billDate)
        },

        billDiners(){
          let mergedDiner = [];

          //Concat all the diners together into one big array
          this.billItems.forEach((item) => {
            item.peopleCombo.forEach((person) => {
              if(mergedDiner.indexOf(person) < 0){
                mergedDiner.push(person)
              }
            })
          });

          return mergedDiner;
        },

        billShareText(){
          var textToShare = [];
          textToShare.push(this.bill.billName || '');

          this.billByPersonSubTotal.forEach( (person) => {
            let billTotal = (Math.round(person.total*100)/100).toFixed(2);

            textToShare.push(`${person.name}: \t$${billTotal}`);
            textToShare.push(`\t - ${person.billSplitItems.join('\t - ')}`);

            console.log(textToShare)

            let links = this.generatePerPersonLinks(billTotal, name);

            if(links.length >= 1){
              links.forEach( (item) => textToShare.push(`${item}`))
            }

            textToShare.push('')
          });

          textToShare.push(`Powered by Bill Snap @ https://billsnap.app`)

          return textToShare.join('\n');
        },
        billSubTotal(){
          if(Object.keys(this.bill).length === 0){
            return 0.00;
          }

          // Calculate subtotal  
          let subTotal = 0;
          this.bill.billItems.forEach((item) => {
            subTotal = parseFloat(item.cost) + parseFloat(subTotal);
          });

          return Math.round(subTotal*100)/100;

        }, 
        originalBillSubtotal(){
          if(Object.keys(this.originalBill).length === 0){
            return 0.00;
          }

          // Calculate subtotal  
          let subTotal = 0;
          this.originalBill.billItems.forEach((item) => {
            subTotal = parseFloat(item.cost) + parseFloat(subTotal);
          });

          return Math.round(subTotal*100)/100;
        },

        billByPersonSubTotal(){
          if(Object.keys(this.bill).length === 0){
            return [];
          }

          var billByPerson = [];

          let allPeople = this.mergedDiners(this.bill.billItems);
          // console.log(allPeople);

          allPeople.forEach((person) => {
            var personTotal = 0;
            var billItemsPerPerson = [];

            this.bill.billItems.forEach((item, index) => {

              if(item.peopleCombo.findIndex(p => p === person) >= 0){

               var totalPeopleSplittingBillItem = item.peopleCombo.length;
               var perPersonBillItemTotal = Math.round( (item.cost/totalPeopleSplittingBillItem) * 100)/100;

               personTotal += perPersonBillItemTotal;
               billItemsPerPerson.push(`${item.title} @\t$${perPersonBillItemTotal.toFixed(2)}${index == this.bill.billItems.length-1 ? '' : '\n'}`);
              }

            });

            billByPerson.push({name: person, total: personTotal, billSplitItems: billItemsPerPerson});

          });

          return billByPerson;
        }
      },
      methods: {
        generatePerPersonLinks(amount, billName){
          var accounts = JSON.parse(window.localStorage.getItem('accounts'));
          var links = [];

          console.log(window.localStorage.getItem('accounts'))
          console.log(accounts)

          if(accounts == null){
            return links;
          }
          
          for(const [key, value] of Object.entries(accounts)){
            switch (key) {
              case 'cash':
                if(value.length == 0){
                  break;
                } else {
                  let cashLink = `Cash: https://cash.app/$${value}/${amount}`
                  links.push(cashLink)
                  break; 
                }
              case 'venmo':
                if(value.length == 0){
                  break;
                } else {
                  let venmoLink = `Venmo: venmo://paycharge?txn=pay&recipients=${value}&amount=${amount}&note=${encodeURIComponent(this.bill.billName)}`
                  links.push(venmoLink)
                  break;
                }
              case 'paypal': 
                if(value.length == 0){
                  break;
                } else {
                  let paypalLink = `Paypal: https://www.paypal.com/paypalme/${value}/${amount}`
                  links.push(paypalLink)
                  break;
                }
              default:
                break;
            }
          }

          return links;

        },
        mergedDiners: function(billItems){
          let mergedDiner = [];

          //Concat all the diners together into one big array
          billItems.forEach((item) => {
            item.peopleCombo.forEach((person) => {
              if(mergedDiner.indexOf(person) < 0){
                mergedDiner.push(person)
              }
            })
          });

          return mergedDiner;
        },

        copyToClipboard(text){
          if(navigator.clipboard){
            navigator.clipboard.writeText(text)
              .then( () => {
                this.showAlert('Successfully copied to clipboard.', 'success')
              }, () => {
                this.showAlert('Cannot copy to clipboard. Select and copy from the modal.', 'error')
              })
          } else {
            console.log(navigator.clipboard)
            
            var textArea = document.createElement("textarea");
            textArea.value = text;
            
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
              var successful = document.execCommand('copy');

              var msg = successful ? 'successful' : 'unsuccessful';

              console.log('Fallback: Copying text command was ' + msg);
              
              if(msg === 'successful'){
                this.showAlert('Successfully copied to clipboard.', 'success')
              }
            } catch (err) {
              console.error('Fallback: Oops, unable to copy', err);
              this.showAlert('You need to copy and paste from the popup text', 'info');
            }

            document.body.removeChild(textArea);

            // this.showAlert('You need to copy and paste from the popup text', 'info');
          }
        },

        addNewPerson(e){
          console.log(e);
        },

        cancelEdit(){
          // console.log(this.bill.billName === this.originalBill.billName);
          if(this.billSubTotal != this.originalBillSubtotal || this.bill.billName != this.originalBill.billName || this.bill.billDate != this.originalBill.billDate){
            console.log('second if')
            this.bill = JSON.parse(JSON.stringify(this.originalBill));
            this.editMode = false;
            this.showAlert('Edit cancelled', 'info');
            return ;
          }

          if(this.edits.length == 0 && (this.billSubTotal === this.originalBillSubtotal || this.bill.billName === this.originalBill.billName || this.bill.billDate === this.originalBill.billDate)){
            console.log('First if')
            this.editMode = false; 
            this.showAlert('Edit canceled', 'info');
            return;
          }

          console.log('Not in ifs')
          this.edits.forEach( (edit, index) => {
            switch(edit.method){
              case 'addPersonToBillItem':
                let otherEditToRemove = this.edits.findIndex( (item) => (item.method == 'removePersonFromBill') && (item.data[0] === edit.data[0]) && (item.data[1] === edit.data[1]) )
                console.log('Other edit to remove is', otherEditToRemove);
                // this.removePersonFromBill(edit.data[0], edit.data[1], true);
                break;
              case 'removePersonFromBill': 
                let otherOtherEditToRemove = this.edits.findIndex( (item) => (item.method == 'addPersonToBillItem') && (item.data[0] === edit.data[0]) && (item.data[1] === edit.data[1]) )
                console.log('Other edit to remove is', otherOtherEditToRemove);
                // this.addPersonToBillItem(edit.data[0], edit.data[1], true);
                break;
              default: 
                console.log('Nothing to do.')
            }

            this.edits.splice(index, 1);

          });
          this.editMode = false;
          this.showAlert('Edit cancelled', 'info');

        },

        addPersonToBillItem(person, billItemId, suppressEdit = false){
          if(this.bill.billItems.find( (item) => item.id === billItemId).peopleCombo.indexOf(person) >= 0){
            this.showAlert('Person is already here.', 'error')
            return;

          } else {

            if(!suppressEdit){
              this.edits.push({method: 'addPersonToBillItem', data: [person, billItemId]});
            }
            this.bill.billItems.find( (item) => item.id === billItemId).peopleCombo.push(person);
          }
        },

        removePersonFromBill(person, billItemId, supressEdit = false){
          let personIndex = this.bill.billItems.find( (item) => item.id === billItemId).peopleCombo.findIndex( (p) => p === person)

          if( this.bill.billItems.find( (item) => item.id === billItemId).peopleCombo.length === 1 ){
            this.showAlert('Yeah, nice try. Add a person first 😉', 'error');
            return;
          } else {
            if(!supressEdit){
              this.edits.push({method: 'removePersonFromBill', data: [person, billItemId]});
            }
            this.bill.billItems.find( (item) => item.id === billItemId).peopleCombo.splice(personIndex, 1);
          }

        },

        formatDate(date){
          if(!date) return null;

          const [year, month, day] = date.split('-')
          return `${month}/${day}/${year}`
        },

        shareBill(){
          if(navigator.share){
            navigator.share({
              text: this.billShareText
            })
            .then(() => console.log('Succesfully shared text'))
            .catch((error) => console.log('Sharing failed', error));

          } else {
            console.log('System does not support sharing.');
            this.shareDialog = true;
          }
        },
        
        saveBill(){

          if(this.edits.length == 0 
              && this.billSubTotal == this.originalBillSubtotal 
              && this.bill.billName == this.originalBill.billName 
              && this.bill.billDate == this.originalBill.billDate
              && this.bill.trip == this.originalBill.trip
            ){
            this.showAlert('Nothing changed, not saving.', 'info');
            this.editMode = false;
            return;
          }     

          let storedBillsData = JSON.parse(window.localStorage.getItem('vbs-data'))
          // console.log(JSON.stringify(storedBillsData))

          // let foundBill = storedBillsData.bills.find( (item) => {
          //   console.log(item)
          //   return item.billId === this.billId
          // })
          // console.log(`Found bill is ${JSON.stringify(foundBill)}`)

          // index of current bill in saved storage
          let foundBillIndex = storedBillsData.bills.findIndex( (item) => item.billId === this.billId)
          // console.log(`Found bill index is: ${foundBillIndex}`)

          storedBillsData.bills.splice(foundBillIndex, 1, this.bill);
          window.localStorage.setItem('vbs-data', JSON.stringify(storedBillsData))

          this.showAlert('Bill updated succesfully!', 'success');
          this.editMode = false;
          this.originalBill = JSON.parse(JSON.stringify(this.bill))

          /*
            1. Parse the saved data into an array 
            2. Find the item trying to be updated
            3. Modify updated item
            4. Update array of parsed saved data
            5. Save data back to localStorage (if possible)
          */
        },
        showAlert(text, type = 'info'){
          this.$emit('alert', {color: type, text: text});
        },
        
      },
      mounted: function(){
        if(!window.localStorage){
          //No localStorage :(
        } else {
          // Get the local data
          let vbsDataString = window.localStorage.getItem('vbs-data');

          // If data is found 
          if(vbsDataString != null){

            let vbsData = JSON.parse(vbsDataString);
            vbsData = vbsData.bills.filter(item => item.billId === this.billId)[0]
            // console.log(vbsData);

            // Set this.bill to the found item
            if(vbsData.trip === null){
              this.bill = {...vbsData, trip: {name: ''}};
              this.originalBill = JSON.parse(JSON.stringify(this.bill));
            } else {
              this.bill = vbsData;
              this.originalBill = JSON.parse(JSON.stringify(this.bill));
            }

            // set the shadowBill 
            
          }

          let tripsStr = window.localStorage.getItem('trips')
          if(tripsStr != null){
            this.trips = JSON.parse(tripsStr).trips
          }
        }
      }
  }
</script>